import xhrCaller from "./xhr-caller";

export const xhrApiLogin = async (u,p) => {
	var result = await xhrCaller({srv: 'api', action: 'Account/Login', method: 'post'});	
	return result;
};

export const xhrApiGetAuth2faKey = async (token) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: 'Account/GetAuth2faKey', method: 'get'});	
	return result;
};

export const xhrApiSendEmailConfirmation = async (email) => {
	var result = await xhrCaller({ bearer: '.', srv: 'api', action: 'Account/SendEmailConfirmation', method: 'post', data: email});	
	return result;
};

export const xhrApiValidateEmailConfirmation = async (data) => {
	var result = await xhrCaller({ bearer: '.', srv: 'api', action: 'Account/ValidateEmailConfirmation', method: 'post', data});	
	return result;
};

export const xhrApiSendAuth2faSetupEmail = async (token) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: 'Account/SendAuth2faSetupEmail', method: 'post', data: { body: ''}});	
	return result;
};

export const xhrApiValidateAuth2faKey = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: 'Account/ValidateAuth2faKey', method: 'post', data});	
	return result;
};

export const xhrApiGetToken = async (token, tenantId) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: 'Account/RefreshToken', method: 'post', data: { "TenId": tenantId }});	
	return result;
};

export const xhrApiGetChatUserAll = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: 'Account/GetChatUserAll', data});	
	return result;
};